import { getImage } from "../data";

export function createTopic(topic, properties = []) {
  return {
    value: topic,
    label: `${topic}-title`,
    properties,
    description: {
      title: `${topic}-title`,
      subtitle: `${topic}-subtitle`,
      body: `${topic}-body`,
    },
  };
}